import { type DeepPartialSkipArrayKey } from 'react-hook-form';

import { type CreateCustomRoleRequest, type UpdateCustomRoleRequest } from '@column/api';

import { EntitiesAndAccounts } from '~/lib/roles/useEntitiesAndAccounts';

// Gets the subset of the request that only contains sandbox/live entities and accounts.
export const buildCreateRequestForEntitiesAndAccountsSubset = (
  data: DeepPartialSkipArrayKey<KeysCamelCaseDeep<CreateCustomRoleRequest>>,
  entitiesAndAccountsSubset: EntitiesAndAccounts
): DeepPartialSkipArrayKey<KeysCamelCaseDeep<CreateCustomRoleRequest>> => ({
  ...data,
  entityLevelOverrides: data.entityLevelOverrides?.filter((override) =>
    entitiesAndAccountsSubset.entities.data.some((entity) => entity.id === override.entityId)
  ),
  bankAccountLevelOverrides: data.bankAccountLevelOverrides?.filter((override) =>
    entitiesAndAccountsSubset.bankAccounts.data.some((bankAccount) => bankAccount.id === override.bankAccountId)
  ),
});

export const buildUpdateRequestForEntitiesAndAccountsSubset = (
  data: DeepPartialSkipArrayKey<KeysCamelCaseDeep<UpdateCustomRoleRequest>>,
  entitiesAndAccountsSubset: EntitiesAndAccounts
): DeepPartialSkipArrayKey<KeysCamelCaseDeep<UpdateCustomRoleRequest>> => ({
  ...data,
  entityLevelOverrides: data.entityLevelOverrides?.filter((override) =>
    entitiesAndAccountsSubset.entities.data.some((entity) => entity.id === override.entityId)
  ),
  bankAccountLevelOverrides: data.bankAccountLevelOverrides?.filter((override) =>
    entitiesAndAccountsSubset.bankAccounts.data.some((bankAccount) => bankAccount.id === override.bankAccountId)
  ),
});
